"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gasEstimateForShieldBaseToken = exports.populateShieldBaseToken = void 0;
const providers_1 = require("../railgun/core/providers");
const tx_gas_details_1 = require("./tx-gas-details");
const blocked_address_1 = require("../../utils/blocked-address");
const engine_1 = require("@railgun-community/engine");
const railgun_1 = require("../railgun");
const error_1 = require("../../utils/error");
const generateShieldBaseTokenTransaction = async (networkName, railgunAddress, shieldPrivateKey, wrappedERC20Amount) => {
    try {
        const relayAdaptContract = (0, providers_1.getRelayAdaptContractForNetwork)(networkName);
        const { masterPublicKey, viewingPublicKey } = engine_1.RailgunEngine.decodeAddress(railgunAddress);
        const random = (0, engine_1.randomHex)(16);
        const { amount, tokenAddress } = wrappedERC20Amount;
        const shield = new engine_1.ShieldNoteERC20(masterPublicKey, random, amount, tokenAddress);
        const shieldRequest = await shield.serialize((0, engine_1.hexToBytes)(shieldPrivateKey), viewingPublicKey);
        const transaction = await relayAdaptContract.populateShieldBaseToken(shieldRequest);
        return transaction;
    }
    catch (err) {
        const sanitizedError = (0, error_1.reportAndSanitizeError)(generateShieldBaseTokenTransaction.name, err);
        throw sanitizedError;
    }
};
const populateShieldBaseToken = async (networkName, railgunAddress, shieldPrivateKey, wrappedERC20Amount, gasDetails) => {
    try {
        (0, railgun_1.assertValidRailgunAddress)(railgunAddress);
        const transaction = await generateShieldBaseTokenTransaction(networkName, railgunAddress, shieldPrivateKey, wrappedERC20Amount);
        if (gasDetails) {
            const sendWithPublicWallet = true;
            (0, tx_gas_details_1.setGasDetailsForTransaction)(networkName, transaction, gasDetails, sendWithPublicWallet);
        }
        return {
            transaction,
        };
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.populateShieldBaseToken.name, err);
    }
};
exports.populateShieldBaseToken = populateShieldBaseToken;
const gasEstimateForShieldBaseToken = async (networkName, railgunAddress, shieldPrivateKey, wrappedERC20Amount, fromWalletAddress) => {
    try {
        (0, railgun_1.assertValidRailgunAddress)(railgunAddress);
        (0, blocked_address_1.assertNotBlockedAddress)(fromWalletAddress);
        const transaction = await generateShieldBaseTokenTransaction(networkName, railgunAddress, shieldPrivateKey, wrappedERC20Amount);
        const sendWithPublicWallet = true;
        const isGasEstimateWithDummyProof = false;
        return (0, tx_gas_details_1.gasEstimateResponse)(await (0, tx_gas_details_1.getGasEstimate)(networkName, transaction, fromWalletAddress, sendWithPublicWallet, false), undefined, // relayerFeeCommitment
        isGasEstimateWithDummyProof);
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.gasEstimateForShieldBaseToken.name, err);
    }
};
exports.gasEstimateForShieldBaseToken = gasEstimateForShieldBaseToken;
